// src/app/models/trace.model.ts

export interface Header {
    EventId: string;
    EventFriendlyName: string;
    EventName: string;
    EventRemark: string;
    MasterCode: string;
  }
  
  export interface SystemInfo {
    Name: string;
    FriendlyName: string | null;
    Type: string | null;
    Id: number;
  }
  
  export interface Systems {
    Source: SystemInfo;
    Target: SystemInfo;
  }
  
  export interface Error {
    Data: string | null;
    StackTrace: string | null;
  }
  
  export interface Trace {
    EventName: string;
    MasterCode: string;
    Message: string;
    RoleName: string;
    FriendlyMessage: string;
    Logs: string;
    Data: string;
    SeverityLevel: string;
    TimeStamp: string;
    Systems: Systems;
    Error: Error;
    isExpanded: boolean;
    EventId: string;
  }
  
  export interface ApiResponse {
    Header: Header;
    Traces: Trace[];
  }
  
  export interface EventMonitoring {
    Name: string;
    FriendlyName: string;
    Remark: string;
    Id: number;
    Producers: SystemInfo[];
    Consumers: SystemInfo[];
  }

  export class EventDetail {
    Name: string = "";
    FriendlyName: string = "";
    Remark: string = "";
    Id: number = 0 ;
    Producers: SystemInfo[] = [];
    Consumers: SystemInfo[] = [];
  }